"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGOUT_MESSAGE_NAME = exports.AUTH_MESSAGE_NAME = exports.AUTH_TOKEN_NAME = void 0;
exports.AUTH_TOKEN_NAME = 'te_auth_token';
exports.AUTH_MESSAGE_NAME = 'te_auth_request';
exports.LOGOUT_MESSAGE_NAME = 'te_auth_logout_request';
